import React from "react";
import { Node } from "../../../utils/funnel/step-node";
import loadable from "@loadable/component";
import { createStepper } from "../../../utils/funnel/stepper";
import { SELL_ONLINE_STEP_KEY } from "../../../constants/sell-online-constant";
const SellOnlineCarCondition = loadable(() =>  import("../sell-online-car-condition"));
const sellOnlineAppointment = loadable(() =>  import("../sell-online-appointment"));

const SELL_ONLINE_FORM_STEPS = [
    new Node({ name: SELL_ONLINE_STEP_KEY.BASIC_DETAILS, component: SellOnlineCarCondition, visited: false}),
    new Node({ name: SELL_ONLINE_STEP_KEY.CAR_CONDITION, component: SellOnlineCarCondition, visited: false}),
    new Node({ name: SELL_ONLINE_STEP_KEY.FINAL_OFFER, component: sellOnlineAppointment, visited: false}),
    new Node({ name: SELL_ONLINE_STEP_KEY.APPOINTMENT_DETAILS, component: sellOnlineAppointment, visited: false}),
    new Node({ name: SELL_ONLINE_STEP_KEY.CONFIRMATION, component: <div>Confirmation</div>, visited: false })
];

export const STEP_CONFIG = {
    stepper: createStepper({ steps: SELL_ONLINE_FORM_STEPS })
};

